import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Cycle = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="m9.822 5.333-1.79 1.79-1.87-1.87a2 2 0 0 0-2.829 0L1.92 6.666a2 2 0 0 0 0 2.828l1.414 1.414a2 2 0 0 0 2.829 0l1.79-1.79 1.87 1.871a2 2 0 0 0 2.828 0l1.414-1.414a2 2 0 0 0 0-2.828L12.65 5.333a2 2 0 0 0-2.828 0Zm-4.603.862 1.87 1.87-1.87 1.901a.667.667 0 0 1-.943 0L2.862 8.552a.667.667 0 0 1 0-.943l1.414-1.414c.26-.26.683-.26.943 0Zm3.675 1.982 1.87-1.9a.666.666 0 0 1 .943 0l1.415 1.413c.26.26.26.683 0 .943l-1.415 1.414a.667.667 0 0 1-.942 0l-1.87-1.87Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Cycle;
